import { FormatContext, ILoadingStrategy } from './loading-strategy-factory';

/**
 * Used to modify the object fit configuration to "cover" for in-article image reveal with 0.95 and 0.80 ratio
 * see https://ogury.atlassian.net/wiki/spaces/COM/pages/71401511/PRD-D+In-Article+Ad
 */
export class InArticleObjectFitCoverStrategy implements ILoadingStrategy {
  private static readonly APPLIED_TO_CREATIVE_RATIOS = [0.8, 0.95];

  alterConfiguration(formatContext: FormatContext): FormatContext {
    formatContext.config = {
      ...formatContext.config,
      creative: {
        ...formatContext.config.creative,
        objectFitStrategy: {
          ...formatContext.config.creative.objectFitStrategy,
          useStrategy: true
        }
      }
    };
    return formatContext;
  }

  isRunnable(formatContext: FormatContext): boolean {
    const { adUnitType, creativeSource, inArticleType } = formatContext.context;
    const creativeRatio = formatContext.config.creative?.creativeRatio;
    return (
      adUnitType === 'in_article' &&
      creativeSource === 'image' &&
      inArticleType === 'reveal' &&
      InArticleObjectFitCoverStrategy.APPLIED_TO_CREATIVE_RATIOS.indexOf(
        creativeRatio
      ) > -1
    );
  }

  onBeforeRender(formatContext: FormatContext): void {}

  onAfterRender(formatContext: FormatContext): void {}

  onResize(formatContext: FormatContext): void {}
}
